export default __webpack_public_path__ + "static/media/sorting.164776fd.png";